import React from 'react';
import type { WebhookProviderCatalogEntry } from '../types';
import { WebhookProviderIcon } from '../webhook-provider-icons';
import { WebhookConfigCard } from './webhook-config-card';

export const WebhookSetupKindSection: React.FC<{
  catalog: WebhookProviderCatalogEntry;
}> = ({ catalog }) => {
  if (catalog.setup.kind === 'manual_instructions') {
    return (
      <WebhookConfigCard
        // The provider's own mark, not a generic wrench: the steps below are
        // carried out in that provider's admin console.
        icon={<WebhookProviderIcon providerKey={catalog.key} />}
        title={`Set up in ${catalog.displayName}`}
        description="Copy the webhook URL below into your provider's admin console. Cotera will verify requests using the signing secret."
      />
    );
  }

  return null;
};
